import { render, staticRenderFns } from "./activity-session-attendee-wrapper.vue?vue&type=template&id=72b3fa81&scoped=true&"
import script from "./activity-session-attendee-wrapper.ts?vue&type=script&lang=ts&"
export * from "./activity-session-attendee-wrapper.ts?vue&type=script&lang=ts&"
import style0 from "./activity-session-attendee-wrapper.scss?vue&type=style&index=0&id=72b3fa81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3fa81",
  null
  
)

export default component.exports